export const MY_FOLDER_CHECK = "common/AddingMyFolder/MY_FOLDER_CHECK";
export const MY_FOLDER_SAVE = "common/AddingMyFolder/MY_FOLDER_SAVE";
